/* Брояч до фиксиран час по софийско време.
   Еднакъв е за всички посетители и НЕ се рестартира при презареждане —
   затова е честен. Показва се само ако офертата наистина се подновява. */
(function () {
  'use strict';

  function sofiaNow() {
    // Стенният часовник в София, изразен като локална дата.
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
  }

  function nextReset(hour) {
    var now = sofiaNow();
    var target = new Date(now);
    target.setHours(hour, 0, 0, 0);
    if (target <= now) target.setDate(target.getDate() + 1);
    return target - now;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-lp-timer]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.lpTimerOn === '1') return;
      el.dataset.lpTimerOn = '1';

      var hour = parseInt(el.dataset.lpTimer, 10);
      if (isNaN(hour) || hour < 0 || hour > 23) hour = 0;

      function tick() {
        var ms = nextReset(hour);
        var s = Math.floor(ms / 1000);
        var h = Math.floor(s / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
